
const enum MarketOperation {
    'Cancelled',
    'TakesPlace',
    'Before',
    'After'

};

const enum Weekday {
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'

};
import { Marketplace } from '../marketplace';
import { Contact } from '../contact';
import { Branch } from '../branch';
export class Marketday {
    constructor(
        public id?: number,
        public marketdayNumber?: string,
        public active?: boolean,
        public name?: string,
        public keyword?: string,
        public marketType?: string,
        public assortment?: string,
        public vatType?: string,
        public unit?: string,
        public classification?: string,
        public onHolidayString?: string,
        public onHoliday?: MarketOperation,
        public dayString?: string,
        public day?: Weekday,
        public startTime?: any,
        public endTime?: any,
        public buildingStartTime?: any,
        public dismantlingEndTime?: any,
        public startTimeWinter?: any,
        public endTimeWinter?: any,
        public buildingStartTimeWinter?: any,
        public dismantlingEndTimeWinter?: any,
        public marketplaceNumber?: string,
        public branchString?: string,
        public updated?: any,
        public created?: any,
        public gguid?: string,
        public marketplace?: Marketplace,
        public marketMaster1?: Contact,
        public marketMaster2?: Contact,
        public marketMaster3?: Contact,
        public branch?: Branch,
    ) {
        this.active = false;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketday/marketday.model.ts